import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../Icons/Icon';

const CarouselControlButton = ({ title, type, onClick }) => {
  const isPrev = type === 'prev';

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={title}
      className={`z-20 absolute top-1/2 transform -translate-y-1/2 ${isPrev ? 'left-4' : 'right-4'
      } bg-black hover:bg-opacity-75 text-white p-1.5 rounded-full focus:outline-none transition-opacity duration-300`}
    >
      <div className="w-4.5 h-4.5 flex items-center justify-center">
        <Icon name="next_arrow" className={`h-2.5 ${isPrev ? 'rotate-180' : ''}`} />
      </div>
    </button>
  );
};

CarouselControlButton.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['prev', 'next']).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CarouselControlButton;
